'use client';
var classes = {"root":"m-fea6bf1a","burger":"m-d4fb9cad"};

export default classes;
//# sourceMappingURL=Burger.module.mjs.map
